import { Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ComponentEditComponent } from '../../modals/component-edit/component-edit.component'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-component-view',
  templateUrl: './component-view.component.html',
  styleUrls: ['./component-view.component.scss']
})
export class ComponentViewComponent implements OnInit {

  @Input() gear;
  @Input() distanceMetric;
  @Input() countryData;
  @Input() componentEdit : OverlayPanel;
  @Output() update = new EventEmitter();

  constructor(
    private modalService : NgbModal
  ) { }

  ngOnInit() {

  }

  editComponent(event){
    const modalRef = this.modalService.open(ComponentEditComponent, {backdrop: 'static', size:'lg', windowClass:'component-modal'});
    modalRef.componentInstance.gear = this.gear;
    modalRef.componentInstance.distanceMetric = this.distanceMetric;
    modalRef.result.then((result) => {
      if(result && result.updated){
        this.update.emit({updated:true});
      }
    }, (onrejected => {    
      
    }));
  }

}
